import errorMessage from './errorMessage';

export default errorMessage;
